<template>
  <div>
    <v-btn
      class="text-capitalize"
      color="green-darken-3"
      variant="tonal"
      @click="generatePDF"
    >
      Gerar Nota
    </v-btn>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { jsPDF } from "jspdf"; // Importando jsPDF

export default defineComponent({
  name: "PrinterComponent",
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    // Função para gerar o PDF com margens laterais menores
    const generatePDF = () => {
      const doc = new jsPDF({
        unit: "mm", // Unidades em milímetros
        format: [80, 297], // Formato de página A4 em milímetros (80mm x 297mm)
      });

      // Definindo margens
      const leftMargin = 5; // Margem esquerda reduzida para 5mm
      const topMargin = 10; // Margem superior
      let y = topMargin; // Posição inicial para o conteúdo

      // Adicionar título
      doc.setFontSize(12);
      doc.text("Comprovante de Pedido", leftMargin, y); // Adicionando título
      y += 10; // Avançando a posição para o próximo elemento

      // Informações do pedido
      doc.setFontSize(10);
      doc.text("Loja Exemplo", leftMargin, y);
      y += 5;
      doc.text("CNPJ: 12.345.678/0001-90", leftMargin, y);
      y += 5;
      doc.text("Rua Exemplo, 123 - Cidade", leftMargin, y);
      y += 10;

      // Informações do usuário
      doc.text(`Nome: ${props.order.user.name}`, leftMargin, y);
      y += 5;
      doc.text(
        `Horário: ${new Date(props.order.createdAt).toLocaleString()}`,
        leftMargin,
        y
      );
      y += 10;

      // Endereço do usuário
      const defaultAddress = props.order.user.addresses.find(
        (address) => address.isDefault === 1
      );
      if (defaultAddress) {
        doc.text("Endereço:", leftMargin, y);
        y += 5;

        // Quebra o endereço em múltiplas linhas, se necessário
        const addressText = `${defaultAddress.street}, ${defaultAddress.number}, ${defaultAddress.neighborhood}, ${defaultAddress.city}, ${defaultAddress.state}, ${defaultAddress.zipCode}, ${defaultAddress.country}`;
        const splitAddress = doc.splitTextToSize(addressText, 70); // Ajuste o valor 70 conforme a largura desejada

        // Imprime cada linha do endereço quebrado
        splitAddress.forEach((line) => {
          doc.text(line, leftMargin, y);
          y += 6; // Ajuste a altura entre as linhas
        });
        y += 10;
      }

      // Dados da compra
      doc.text(
        "Qtd.         Descrição                   Preço     Observação",
        leftMargin,
        y
      );
      y += 5;
      doc.text(
        "-----------------------------------------------------------",
        leftMargin,
        y
      );
      y += 5;

      // Adicionar itens da compra
      props.order.items.forEach((item) => {
        const observation = item.observations
          ? item.observations.toUpperCase()
          : "N/A"; // Verifica se há observação
        const formattedText = `${item.quantity}x  ${item.item.name.padEnd(
          20
        )}  ${item.unitPrice}  ${observation}`;
        doc.text(formattedText, leftMargin, y);
        y += 6; // Ajuste para o próximo item
      });

      // Total
      y += 10;
      doc.setFontSize(12);
      doc.text(
        `Total: R$ ${parseFloat(props.order.totalAmount).toFixed(2)}`,
        leftMargin,
        y
      );

      // Salvar PDF com nome incluindo o ID do pedido
      doc.save(`comprovante-de-pedido-${props.order.orderId}.pdf`);
    };

    return {
      generatePDF, // Expondo a função de gerar PDF
    };
  },
});
</script>

<style lang="scss" scoped>
.box {
  h5 {
    font-size: 16px;
  }
  .list {
    list-style-type: none;

    li {
      margin-bottom: 13px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .box {
    h5 {
      font-size: 15px;
    }
  }
}
</style>
